import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Agents } from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-manage-customers',
  templateUrl: './manage-customers.component.html',
  styleUrls: ['./manage-customers.component.css']
})
export class ManageCustomersComponent implements OnInit {

  public despositionArray   : any = AppSettings.disposition;
  public documentTypeArray  : any = AppSettings.documentType;
  public siteAbbr           : any = AppSettings.siteAbbr;
  public tabs               : any = [
                                      { tabName: 'Checked Prices',         thName: 'Leads'        },
                                      { tabName: 'Unpaid',                 thName: 'unpaid order' },
                                      { tabName: 'Paid',                   thName: 'paid order'   },
                                      { tabName: 'All Customers',          thName: 'Customer'     },
                                      // { tabName: 'All types of customers', thName: ''             }
                                    ];
  public activeTab          : any = this.tabs[0];
  public loading            : any = false;
  public paginatePage       : any;
  public leads              : any = [];
  public custOrders         : any = [];
  public comments           : any = [];
  public agentComments      : any = [];
  public qaComments         : any = [];
  public agentsSub          : any;
  public agents             : any;
  public qa                 : any;
  public loader             : any;


  @ViewChild(DataTableDirective)
  public dtElement    : DataTableDirective;
  public dtOptions    : DataTables.Settings = {};
  public dtOptions1    : DataTables.Settings = {};
  public dtTrigger    : any = new Subject();

  public searchParams          : any = { info: '', date_from: '', date_to: '', noOfOrders: null, paid: null, minLimit: null, maxLimit:null, site_link: null };
  public minLimit              : any = [
                                          { val: 1, name: '1' },
                                          { val: 2, name: '2' },
                                          { val: 3, name: '3' },
                                          { val: 4, name: '4' },
                                          { val: 5, name: '> 5' },
                                      ];
  public fullRangeDate         : any;
  public selectedDesposition   : any;
  public siteLinks   : any = [];

  constructor(
    private helperService     : HelperService,
    private agentsService     : Agents,
    private cdr               : ChangeDetectorRef
  ) {

    this.getSiteLinks();

    // Get Agents
    this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
      if (agents) {
        this.agents = agents.agents;
        this.qa     = agents.qa;
      }
    });

      this.dtOptions = {
        paging: true,
        info: true,
        // ordering: false,
        pagingType: 'full_numbers',
        pageLength: 10,
        serverSide: true,
        processing: true,
        searching: false,
        'language': AppSettings.dataTableLang,
        "columnDefs": [
          { "orderable": false,                                                                                           "targets": 0 },
          { "orderable": false,                                                                                           "targets": 1 },
          { "orderable": false,                                                                                           "targets": 2 },
          { "orderable": false,                                                                                           "targets": 3 },
          { "orderable": false,                                                                                           "targets": 4 },
          { "orderable": false, "visible": this.activeTab.tabName == 'Pad' || this.activeTab.tabName == 'Unpaid',         "targets": 5 },
          { "orderable": false, "visible": this.activeTab.tabName == 'All Customers',                                     "targets": 6 },
          { "orderable": false, "visible": this.activeTab.tabName == 'All Customers',                                     "targets": 7 },
        ],
        "order": [[ 0, "desc" ]],
        ajax: (dataTablesParameters: any, callback) => {

          // Show Loader
          this.loading = true;
          // console.log("dataTablesParameters", dataTablesParameters);
          let url  = '';
          console.log("activeTab.tabName", this.activeTab.tabName);

          if(this.activeTab.tabName == 'Checked Prices')
            url  = AppSettings.API_ENDPOINT + 'admin/get-leads-wrs';
          else if(this.activeTab.tabName == 'All Customers')
            url  = AppSettings.API_ENDPOINT + 'admin/get-all-customers';
          else
            url  = AppSettings.API_ENDPOINT + 'admin/get-customers-wro';

          let dtParams = {
                          paid_check        : this.activeTab.tabName,
                          info              : this.searchParams.info,
                          minLimit          : this.searchParams.minLimit,
                          maxLimit          : this.searchParams.maxLimit,
                          noOfOrders        : this.searchParams.noOfOrders,
                          paid              : this.searchParams.paid,
                          site_link         : this.searchParams.site_link,
                          date_from         : this.searchParams.date_from ? this.helperService.caonvertDateToString(this.searchParams.date_from) : '',
                          date_to           : this.searchParams.date_to   ? this.helperService.caonvertDateToString(this.searchParams.date_to, false)   : '',
                          start             : dataTablesParameters.start,
                          length            : dataTablesParameters.length,
                          order             : dataTablesParameters.order,
                          columns           : dataTablesParameters.columns
                        };


          // For Record Serial Numbers
          this.paginatePage = dataTablesParameters.start;

          // Empty Data
          this.leads = [];

          this.helperService.httpPostRequestsDecryp(url, dtParams)
            .then( resp => {
                this.leads        = JSON.parse(resp);

                // Set Default page len
                this.dtOptions.pageLength = this.dtElement['dt'].page.len();

                // Hide Loader
                this.loading = false;

                callback({
                  recordsTotal: this.leads.total,
                  recordsFiltered: this.leads.total,
                  // recordsFiltered: resp['recordsFiltered'],
                  // recordsFiltered: 1000,
                  data: []
                });

                // // $(".paginate_button .current").css("color", "white");
                // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
                $('div.dataTables_length select').addClass('dt-form-control');
                $('div.dataTables_filter input').addClass('dt-form-control');
            })
            .catch(error => {
                // Set loader false
                this.loading = false;

                // // Rerender DT in case of failure
                // this.rerender();

                console.log("error: ",error);
            });
        },
        columns: [
          { data: 'id' },
          { data: 'timestamp' },
          { data: 'phoneEmail' },
          { data: 'price_noOfPages' },
          { data: 'academic_level' },
          { data: 'document_type' },
          { data: 'site_link' },
          { data: 'paid' },
        ],
        // Use this attribute to enable the responsive extension
        responsive: false
      }
  }

  ngOnInit() {
  }

  ngAfterViewInit(){
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();

    if (typeof this.agentsSub != 'undefined') {
      //prevent memory leak when component destroyed
      this.agentsSub.unsubscribe();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      // Destroy the table first
      dtInstance.destroy();

      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  splitFromTo(){
    if(this.fullRangeDate){
      this.searchParams.date_from = this.fullRangeDate[0];
      this.searchParams.date_to =   this.fullRangeDate[1];

      this.rerender();
    }
  }

  setActiveTab(tab) {
    this.leads = [];
    this.activeTab = tab;
    if(this.activeTab.tabName == "Checked Prices"){
      this.dtOptions.columnDefs[2].visible = true;
      this.dtOptions.columnDefs[3].visible = true;
      this.dtOptions.columnDefs[4].visible = true;
      this.dtOptions.columnDefs[5].visible = false;
      this.dtOptions.columnDefs[6].visible = false;
      this.dtOptions.columnDefs[7].visible = false;
    }
    else if(this.activeTab.tabName == "All Customers"){
      this.dtOptions.columnDefs[2].visible = false;
      this.dtOptions.columnDefs[3].visible = false;
      this.dtOptions.columnDefs[4].visible = false;
      this.dtOptions.columnDefs[5].visible = false;
      this.dtOptions.columnDefs[6].visible = true;
      this.dtOptions.columnDefs[7].visible = true;
    }
    else{
      this.dtOptions.columnDefs[2].visible = true;
      this.dtOptions.columnDefs[3].visible = true;
      this.dtOptions.columnDefs[4].visible = true;
      this.dtOptions.columnDefs[5].visible = true;
      this.dtOptions.columnDefs[6].visible = false;
      this.dtOptions.columnDefs[7].visible = false;
    }
    this.cdr.detectChanges();
    this.clearFilters();
  }

  showOrders(orders) {
    this.custOrders = orders;

    // Show Orders
    $("#moreOrders").modal("show");
  }

  updateDesposition(lead, index){
    let url = AppSettings.API_ENDPOINT + "admin/update-lead-status";
    let data = { id: lead.id, status: lead.status };
    this.helperService.httpPostRequests(url,data).then(resp => {
      if(typeof resp != "undefined") {
        // this.leads =
        // this.rerender();
      }
    });
  }

  updateAgent(lead, index){
    console.log("lead", lead);

    let url = AppSettings.API_ENDPOINT + "admin/update-lead-agent";
    let data = { val: lead.agent_id, oid : lead.id };
    this.helperService.httpPostRequests(url,data).then(resp => {
      if(typeof resp != "undefined" && resp.status == "OK") {
        Swal.fire('', resp.message , 'success');
      }
      if(typeof resp != "undefined" && resp.status == "ERROR") {
        Swal.fire('', resp.message , 'error');
      }
    });
  }

  showComments(lead,index){
    // this.loader = true;
    // console.log("this.lead", lead);

    this.loader = lead.id;

    let url = AppSettings.API_ENDPOINT + "shared/get-comments";
    let data = { l : lead.id, type: '' };
    this.helperService.httpPostRequests(url,data).then(resp => {
      if(typeof resp != "undefined") {
        // console.log("resp", resp);
        this.comments = resp.data;
        this.agentComments = [];
        this.qaComments    = [];

        for (let i = 0; i < this.comments.length; i++) {
          if (this.comments[i].type == "Leads-Comments") {
            this.agentComments.push(this.comments[i]);
          }
          else if(this.comments[i].type == "QA-Leads-Comments"){
            this.qaComments.push(this.comments[i]);
          }
          else{}
        }


        if (this.agentComments.length == 0 && this.qaComments.length == 0) {
          Swal.fire('No comments', "Agents and QA haven't added any comment yet." , 'info');
          this.loader = '';
        }
        else{
          if (typeof $ != "undefined") {
            this.loader = '';
            $("#comment_modal"+index).modal("show");
          }
        }
        $(".modal-backdrop").click(function(){
            $("#comment_modal"+index).modal("hide");
        });


      }

    });
  }

  getSiteLinks() {
    let data = '';
    let url  = AppSettings.API_ENDPOINT + 'get-site-links';
      this.helperService.httpPostRequests(url,data).then(resp => {
          console.log('SITE LINKS ---> ', resp);
          this.siteLinks = resp.data;
          this.cdr.detectChanges();
      }).catch(error => {
        console.error("error: ",error);
      });
  }

  prepareExcelData(){
    // Set HEader
    let headers = {
      serial_num         : "S. No",
      name               : "Name",
      email              : "Email",
      phone              : "Phone",
      site_link          : "Site Link"
    };

    // let url = AppSettings.API_ENDPOINT + "admin/get-all-customers-for-excel";
    // let data = {};
    //
    // this.helperService.httpPostRequests(url,data).then(resp => {
    //   if(typeof resp != "undefined") {
    //     console.log("resp", resp);
    //   }
    //
    // });

    //
    let itemsFormatted = [];
    let serial_num = 0;
    // format the data
    this.leads.data.forEach((item) => {
      serial_num++;
      itemsFormatted.push({
        serial_num         : serial_num,
        name               : item.name         ? item.name.replace(/,/g, '')         : (item.first_name ? item.first_name.replace(/,/g, '') : ''),
        email              : item.email        ? item.email.replace(/,/g, '')        : '',
        phone              : item.phone        ? item.phone.replace(/,/g, '')        : '',
        site_link          : item.site_link    ? item.site_link.replace(/,/g, '')    : ''
      });
    });

    // Set file title
    let fileTitle = 'Leads Information ';

    Swal.fire({
      type: 'success',
      title: 'Success',
      text: 'Data Downloaded SuccessFully',
      //html: '<div class="gif_pop_wrapper"><div class="dwn_gif_wrap"><img src="assets/images/download_gif.gif"></div><p>Data Downloaded successfully!!</p></div>',
      showCancelButton: false,
      timer: 3000
      })

    // Export File
    this.exportCSVFile(headers, itemsFormatted, fileTitle);
  }



  exportCSVFile(headers, items, fileTitle) {
      if (headers) {
          items.unshift(headers);
      }

      // Convert Object to JSON
      var jsonObject       = JSON.stringify(items);
      var csv              = this.convertToCSV(jsonObject);
      var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
          var link = document.createElement("a");
          if (link.download !== undefined) { // feature detection
              // Browsers that support HTML5 download attribute
              var url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", exportedFilenmae);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          }
      }
  }

  convertToCSV(objArray) {
      var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      var str = '';
      for (var i = 0; i < array.length; i++) {
          var line = '';
          for (var index in array[i]) {
              if (line != '') line += ','
              line += '"' + array[i][index] + '"';
          }
          str += line + '\r\n';
      }
      return str;
  }

  agentSearch(id, agentArr) {
    for (var i = 0; i < agentArr.length; i++) {
      if (agentArr[i].id === id) {
        return agentArr[i].name;
      }
    }
  }
  totalPaymentSearch(id, despoArr){
    for (var i = 0; i < despoArr.length; i++) {
      if (despoArr[i].value === id) {
        return despoArr[i].name;
      }
    }
  }

  clearFilters(){
    this.fullRangeDate = '';
    this.searchParams = { info: '', date_from: '', date_to: '', noOfOrders: null, paid: null, minLimit: null, maxLimit:null, site_link: null };

    this.rerender();
  }

}
